import {
  validateEmail as validateEmailShared,
  validatePhone as validatePhoneShared,
  normalizeString as normalizeStringShared,
} from '../../../utils/validationUtils';

/**
 * Filtra usuarios por término de búsqueda
 * @param {Array} users - Lista de usuarios
 * @param {string} searchTerm - Término de búsqueda
 * @returns {Array} - Usuarios filtrados
 */
export const filterUsers = (users, searchTerm) => {
  if (!searchTerm.trim()) {
    return users;
  }

  const term = searchTerm.toLowerCase();
  return users.filter(
    (user) =>
      user.names?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term) ||
      user.telephone?.toLowerCase().includes(term)
  );
};

/**
 * Valida un email
 * @param {string} email - Email a validar
 * @returns {boolean} - True si es válido
 */
export const validateEmail = (email) => validateEmailShared(email, { optional: false });

/**
 * Valida un teléfono
 * @param {string} phone - Teléfono a validar
 * @returns {boolean} - True si es válido
 */
export const validatePhone = (phone) => validatePhoneShared(phone, { optional: true });

/**
 * Valida una contraseña
 * @param {string} password - Contraseña a validar
 * @returns {boolean} - True si es válida
 */
export const validatePassword = (password) => {
  if (!password) return false;
  return password.length >= 8;
};

/**
 * Valida el nombre
 * @param {string} name - Nombre a validar
 * @returns {boolean} - True si es válido
 */
export const validateName = (name) => {
  if (!name) return false;
  return name.trim().length >= 2 && name.trim().length <= 100;
};

/**
 * Obtiene el primer nombre del usuario
 * @param {string} fullName - Nombre completo
 * @returns {string} - Primer nombre
 */
export const getFirstName = (fullName) => {
  if (!fullName) return '';
  return fullName.split(' ')[0];
};

/**
 * Formatea el rol del usuario para mostrar
 * @param {Object} role - Objeto del rol
 * @returns {string} - Nombre del rol formateado
 */
export const formatUserRole = (role) => {
  if (!role) return 'Sin rol';
  return role.name || 'Rol desconocido';
};

/**
 * Normaliza un string removiendo acentos y convirtiendo a minúsculas
 * @param {string} str - String a normalizar
 * @returns {string} - String normalizado
 */
export const normalizeString = (str) => normalizeStringShared(str);

/**
 * Prepara los datos del usuario para envío a la API
 * @param {Object} user - Datos del usuario
 * @returns {Object} - Datos preparados para la API
 */
export const prepareUserData = (user) => {
  const cleanedData = { ...user };

  // Limpiar campos vacíos
  Object.keys(cleanedData).forEach((key) => {
    if (cleanedData[key] === '' || cleanedData[key] === null) {
      delete cleanedData[key];
    }
  });

  return cleanedData;
};
